import React from 'react';
import { array, bool, func } from 'prop-types';
import { Text, Icon, Loading } from '../../../common';
import Table from '../../../common/Table';
import { StyledTableWrapper } from '../styles';

const PendingOrders = ({ orders, loading, onEyeClick }) => {
    if (loading) {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <Loading loading={true} />
            </div>
        );
    }

    // Si orders es null, no mostrar nada (estado inicial)
    if (orders === null) {
        return null;
    }

    // Si orders es un array vacío, mostrar mensaje
    if (orders.length === 0) {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <Icon name='information-circle' size={48} color='#d9d9d9' style={{ marginBottom: 16 }} />
                <Text text='No hay pedidos pendientes en este momento' size={14} color='#8c8c8c' />
            </div>
        );
    }

    const columns = [
        {
            title: 'N° Orden',
            dataIndex: 'orderId',
            render: (text) => <Text text={text} size={13} style={{}} />,
            thStyle: { 
                textAlign: 'left', 
                padding: '14px 16px',
                width: '35%',
                backgroundColor: '#fafafa',
                borderBottom: 'none',
                fontWeight: 600,
                fontSize: '13px',
                color: '#262626'
            },
            tdStyle: { 
                padding: '14px 16px', 
                borderBottom: '1px solid #f0f0f0',
                verticalAlign: 'middle'
            }
        },
        {
            title: 'Cantidad de Items',
            dataIndex: 'itemCount',
            render: (text) => <Text text={text} size={13} />,
            thStyle: { 
                padding: '14px 16px',
                width: '20%',
                backgroundColor: '#fafafa',
                borderBottom: 'none',
                fontWeight: 600,
                fontSize: '13px',
                color: '#262626'
            },
            tdStyle: { 
                padding: '14px 16px', 
                borderBottom: '1px solid #f0f0f0',
                verticalAlign: 'middle'
            }
        },
        {
            title: 'Fecha de entrega',
            dataIndex: 'deliveryDate',
            render: (text) => {
                if (!text) return <Text text='-' size={13} color='#999' />;
                // Formatear fecha: "30/11/2025 10:00"
                const date = new Date(text);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                return (
                    <div style={{ lineHeight: '1.6' }}>
                        <div style={{ fontSize: '13px', fontWeight: 500, color: '#262626' }}>
                            {`${day}/${month}/${year}`}
                        </div>
                        <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                            {`${hours}:${minutes}`}
                        </div>
                    </div>
                );
            },
            thStyle: { 
                padding: '14px 16px',
                width: '25%',
                backgroundColor: '#fafafa',
                borderBottom: 'none',
                fontWeight: 600,
                fontSize: '13px',
                color: '#262626'
            },
            tdStyle: {
                padding: '14px 16px', 
                borderBottom: '1px solid #f0f0f0',
                verticalAlign: 'middle'
            }
        },
        {
            title: 'Acción',
            dataIndex: 'orderId',
            render: (text, record) => (
                <Icon 
                    name='eye' 
                    size={16} 
                    color='#1FA02E' 
                    style={{ cursor: 'pointer' }} 
                    onClick={() => onEyeClick && onEyeClick(record)}
                />
            ),
            thStyle: { 
                textAlign: 'center', 
                padding: '14px 16px',
                width: '20%',
                backgroundColor: '#fafafa',
                borderBottom: 'none',
                fontWeight: 600,
                fontSize: '13px',
                color: '#262626'
            },
            tdStyle: { 
                textAlign: 'center', 
                padding: '14px 16px', 
                borderBottom: '1px solid #f0f0f0',
                verticalAlign: 'middle'
            }
        }
    ];

    return (
        <StyledTableWrapper>
            <Table
                columns={columns}
                data={orders}
            />
        </StyledTableWrapper>
    );
};

PendingOrders.propTypes = {
    orders: array,
    loading: bool,
    onEyeClick: func
};

PendingOrders.defaultProps = {
    orders: [],
    loading: false,
    onEyeClick: null
};

export default PendingOrders;
